import { render, staticRenderFns } from "./PettycashDocument.vue?vue&type=template&id=4d6bd1b2&scoped=true"
import script from "./PettycashDocument.vue?vue&type=script&lang=js"
export * from "./PettycashDocument.vue?vue&type=script&lang=js"
import style0 from "./PettycashDocument.vue?vue&type=style&index=0&id=4d6bd1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6bd1b2",
  null
  
)

export default component.exports